import {Component, OnInit, ViewChild} from '@angular/core';
import {MatButton} from '@angular/material/button';
import {MatProgressBar} from '@angular/material/progress-bar';
import {UserService} from '../../../shared/services/user.service';
import {ActivatedRoute, Router} from '@angular/router';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {CustomValidators} from 'ngx-custom-validators';
import {Store} from '@ngxs/store';
import {Observable} from 'rxjs';
import {CurrentUser} from '../../../shared/models/current-user.model';
import {StorageService} from '../../../shared/services/storage.service';
import {PopupWindowsService} from '../../../shared/services/popup-windows.service';

@Component({
    selector: 'app-new-password',
    templateUrl: './new-password.component.html',
    styleUrls: ['./new-password.component.css']
})
export class NewPasswordComponent implements OnInit {
    newPasswordForm: FormGroup;
    token: string;
    email: string;
    @ViewChild(MatProgressBar) progressBar: MatProgressBar;
    @ViewChild(MatButton) submitButton: MatButton;
    currentUser$: Observable<CurrentUser>;

    constructor(
        private userService: UserService,
        private route: ActivatedRoute,
        private  router: Router,
        private fb: FormBuilder,
        private store: Store,
        private storageService: StorageService,
        private popupWindowsService: PopupWindowsService
    ) {
        this.currentUser$ = this.store.select(state => state.currentUser.currentUser);
    }

    ngOnInit() {
        this.route.paramMap.subscribe(params => {
            this.route.queryParamMap.subscribe(queryParams => {
                this.token = queryParams.get('token');
                this.email = queryParams.get('email');
            });
        });
        const password = new FormControl('', Validators.required);
        const confirmPassword = new FormControl('', CustomValidators.equalTo(password));
        this.newPasswordForm = this.fb.group({
            password: password,
            confirmPassword: confirmPassword
        });
    }

    submitNewPassword() {
        this.submitButton.disabled = true;
        this.progressBar.mode = 'indeterminate';
        this.userService.newPassword(this.email, this.newPasswordForm.value.password, this.token).subscribe(
            data => {
                this.submitButton.disabled = false;
                this.progressBar.mode = 'determinate';
                this.router.navigate(['/sessions/signin_user']);
            },
            err => {
                this.submitButton.disabled = false;
                this.progressBar.mode = 'determinate';
                this.popupWindowsService.openErrorDialogWindow({message: err.error.detail});
            }
        );
    }

}
